export default "__VITE_ASSET__Dlfprz1R__"